import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-05046178"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  id: "search-container",
  "class": "tw-max-w-[960px] tw-mx-auto tw-z-10 tw-relative tw-pt-5px sm:tw-pt-0 tw-mb-10px"
};
var _hoisted_2 = {
  id: "box-sm",
  "class": "tw-bg-w-cultured tw-pt-20px tw-pb-25px tw-px-25px tw-rounded-xl",
  style: {
    "min-height": "163px"
  }
};
var _hoisted_3 = {
  id: "myTab",
  "class": "nav nav-tabs tw-justify-center tw-px-0 tw-hidden sm:tw-flex tw-gap-20px md:tw-gap-30px",
  role: "tablist"
};
var _hoisted_4 = {
  id: "sale-tab",
  "data-cy": "sale-tab",
  "class": "nav-item",
  role: "presentation"
};
var _hoisted_5 = ["aria-selected", "innerHTML"];
var _hoisted_6 = {
  id: "rent-tab",
  "data-cy": "rent-tab",
  "class": "nav-item"
};
var _hoisted_7 = ["aria-selected", "innerHTML"];
var _hoisted_8 = {
  key: 0,
  id: "sell-tab",
  "data-cy": "sell-tab",
  "class": "nav-item"
};
var _hoisted_9 = ["aria-selected", "innerHTML"];
var _hoisted_10 = {
  key: 1,
  id: "valuation-tab",
  "data-cy": "valuation-tab",
  "class": "nav-item"
};
var _hoisted_11 = ["aria-selected", "innerHTML"];
var _hoisted_12 = {
  key: 2,
  id: "auction-tab",
  "data-cy": "auction-tab",
  "class": "nav-item sm:max-md:!tw-hidden"
};
var _hoisted_13 = ["aria-selected", "innerHTML"];
var _hoisted_14 = {
  key: 3,
  id: "agency-tab",
  "data-cy": "agency-tab",
  "class": "nav-item"
};
var _hoisted_15 = ["aria-selected", "innerHTML"];
var _hoisted_16 = {
  key: 4,
  id: "trend-tab",
  "data-cy": "trend-tab",
  "class": "nav-item"
};
var _hoisted_17 = ["aria-selected", "innerHTML"];
var _hoisted_18 = {
  id: "myTabPane",
  "data-cy": "myTabPane",
  "class": "tab-content tw-mt-20px"
};
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "tw-inline-block tw-self-stretch tw-w-[1px] tw-min-h-[1px] tw-my-20px",
    style: {
      "border": "1px solid rgb(234, 239, 253)",
      "opacity": "1"
    }
  }, null, -1 /* HOISTED */);
});
var _hoisted_20 = {
  key: 1,
  "class": "tw-inline-block tw-self-stretch tw-w-[1px] tw-min-h-[1px] tw-my-20px",
  style: {
    "border": "1px solid rgb(234, 239, 253)",
    "opacity": "1"
  }
};
var _hoisted_21 = {
  key: 3,
  "class": "tw-inline-block tw-self-stretch tw-w-[1px] tw-min-h-[1px] tw-my-20px",
  style: {
    "border": "1px solid rgb(234, 239, 253)",
    "opacity": "1"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_listing_typology_multi_select = _resolveComponent("listing-typology-multi-select");
  var _component_accessible_select = _resolveComponent("accessible-select");
  var _component_base_input = _resolveComponent("base-input");
  var _component_place_box = _resolveComponent("place-box");
  var _component_base_button = _resolveComponent("base-button");
  var _component_auction_filters = _resolveComponent("auction-filters");
  var _component_base_drop_down = _resolveComponent("base-drop-down");
  var _component_map_modal = _resolveComponent("map-modal");
  var _component_filters_agency_modal = _resolveComponent("filters-agency-modal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createCommentVNode("TAB "), _createElementVNode("ul", _hoisted_3, [_createElementVNode("li", _hoisted_4, [_createElementVNode("a", {
    "class": _normalizeClass(["nav-link tw-text-16 tw-bg-w-cultured", {
      active: _ctx.isTabActive(_ctx.TABTYPE.SALE)
    }]),
    "data-toggle": "tab",
    "data-field-target": "Contratto",
    role: "tab",
    href: "#filters-tab-pane",
    "aria-selected": _ctx.isTabActive(_ctx.TABTYPE.SALE),
    onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
      return _ctx.activeTab = _ctx.TABTYPE.SALE;
    }, ["prevent"])),
    innerHTML: _ctx.labels.homeSale
  }, null, 10 /* CLASS, PROPS */, _hoisted_5)]), _createElementVNode("li", _hoisted_6, [_createElementVNode("a", {
    "class": _normalizeClass(["nav-link tw-text-16 tw-bg-w-cultured", {
      active: _ctx.isTabActive(_ctx.TABTYPE.RENT)
    }]),
    "data-toggle": "tab",
    "data-field-target": "Contratto",
    role: "tab",
    href: "#filters-tab-pane",
    "aria-selected": _ctx.isTabActive(_ctx.TABTYPE.RENT),
    onClick: _cache[1] || (_cache[1] = _withModifiers(function ($event) {
      return _ctx.activeTab = _ctx.TABTYPE.RENT;
    }, ["prevent"])),
    innerHTML: _ctx.labels.homeRent
  }, null, 10 /* CLASS, PROPS */, _hoisted_7)]), _createCommentVNode(" sell tab "), _ctx.sell_tab ? (_openBlock(), _createElementBlock("li", _hoisted_8, [_createElementVNode("a", {
    "class": _normalizeClass(["nav-link tw-text-16 tw-bg-w-cultured", {
      active: _ctx.isSellingActive
    }]),
    "data-toggle": "tab",
    "data-field-target": "Vendi",
    role: "tab",
    href: "#sell-tab-pane",
    "aria-controls": "sell-tab-pane",
    "aria-selected": _ctx.isSellingActive,
    onClick: _cache[2] || (_cache[2] = _withModifiers(function ($event) {
      return _ctx.activeTab = _ctx.TABTYPE.SELLING;
    }, ["prevent"])),
    innerHTML: _ctx.labels.sell
  }, null, 10 /* CLASS, PROPS */, _hoisted_9)])) : _createCommentVNode("v-if", true), _ctx.valuation_tab ? (_openBlock(), _createElementBlock("li", _hoisted_10, [_createElementVNode("a", {
    "class": _normalizeClass(["nav-link tw-text-16 tw-bg-w-cultured", {
      active: _ctx.isValuationActive
    }]),
    "data-toggle": "tab",
    "data-field-target": "Valuta",
    role: "tab",
    href: "#valuation-tab-pane",
    "aria-controls": "valuation-tab-pane",
    "aria-selected": _ctx.isValuationActive,
    onClick: _cache[3] || (_cache[3] = _withModifiers(function ($event) {
      return _ctx.activeTab = _ctx.TABTYPE.VALUATE;
    }, ["prevent"])),
    innerHTML: _ctx.labels.valuate
  }, null, 10 /* CLASS, PROPS */, _hoisted_11)])) : _createCommentVNode("v-if", true), _ctx.auction_tab ? (_openBlock(), _createElementBlock("li", _hoisted_12, [_createElementVNode("a", {
    "class": _normalizeClass(["nav-link tw-text-16 tw-bg-w-cultured", {
      active: _ctx.isAuctionActive
    }]),
    "data-toggle": "tab",
    "data-field-target": "Contratto",
    role: "tab",
    href: "#filters-tab-pane",
    "aria-selected": _ctx.isAuctionActive,
    onClick: _cache[4] || (_cache[4] = _withModifiers(
    //@ts-ignore
    function () {
      return _ctx.setAuctionTabActive && _ctx.setAuctionTabActive.apply(_ctx, arguments);
    }, ["prevent"])),
    innerHTML: _ctx.labels.auction
  }, null, 10 /* CLASS, PROPS */, _hoisted_13)])) : _createCommentVNode("v-if", true), _ctx.agency_tab ? (_openBlock(), _createElementBlock("li", _hoisted_14, [_createElementVNode("a", {
    "class": _normalizeClass(["nav-link tw-text-16 tw-bg-w-cultured", {
      active: _ctx.isAgencyActive
    }]),
    "data-toggle": "tab",
    "data-field-target": "Tipologia",
    role: "tab",
    href: "#filters-tab-pane",
    "aria-selected": _ctx.isSearchActive,
    onClick: _cache[5] || (_cache[5] = _withModifiers(
    //@ts-ignore
    function () {
      return _ctx.setAgencyTabActive && _ctx.setAgencyTabActive.apply(_ctx, arguments);
    }, ["prevent"])),
    innerHTML: _ctx.labels.agencies
  }, null, 10 /* CLASS, PROPS */, _hoisted_15)])) : _createCommentVNode("v-if", true), _ctx.trend_tab ? (_openBlock(), _createElementBlock("li", _hoisted_16, [_createElementVNode("a", {
    "class": _normalizeClass(["nav-link tw-text-16 tw-bg-w-cultured", {
      active: _ctx.isTrendActive
    }]),
    "data-toggle": "tab",
    href: "#filters-tab-pane",
    role: "tab",
    "aria-controls": "trend-tab-pane",
    "aria-selected": _ctx.isTrendActive,
    onClick: _cache[6] || (_cache[6] = _withModifiers(function ($event) {
      return _ctx.activeTab = _ctx.TABTYPE.TREND;
    }, ["prevent"])),
    innerHTML: _ctx.labels.trend
  }, null, 10 /* CLASS, PROPS */, _hoisted_17)])) : _createCommentVNode("v-if", true)]), _createCommentVNode("TAB CONTENT"), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
    id: "filters-tab-pane",
    "class": _normalizeClass(["tab-pane tw-grid tw-grid-cols-4 tw-bg-white tw-rounded-xl tw-h-[90px]", {
      'active show': _ctx.isSearchActive || _ctx.isTrendActive || _ctx.isAgencyActive
    }]),
    role: "tabpanel"
  }, [_ctx.isSearchActive ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": _normalizeClass(["tw-flex tw-items-center", {
      'lg:tw-mb-0': _ctx.not_found
    }])
  }, [_createVNode(_component_listing_typology_multi_select, {
    id: "listingTypology",
    "data-cy": "listing-typology-multi-select",
    "dropdown-classes": "tw-z-[1000]",
    "listing-typologies": _ctx.listingTypologies,
    onClick: _ctx.closePlaceDropdown,
    onTypologyListChanged: _ctx.onLTMSChange
  }, null, 8 /* PROPS */, ["listing-typologies", "onClick", "onTypologyListChanged"]), _hoisted_19], 2 /* CLASS */)) : _createCommentVNode("v-if", true), _createElementVNode("div", {
    "class": _normalizeClass(["tw-col-span-3 tw-flex tw-items-center tw-relative", {
      'tw-pl-25px': _ctx.isTrendActive,
      'tw-pl-0 !tw-col-span-full': _ctx.isAgencyActive || _ctx.isTrendActive
    }])
  }, [_ctx.isAgencyActive ? (_openBlock(), _createBlock(_component_accessible_select, {
    key: 0,
    "data-cy": "agency-group-select",
    "class": "tw-min-w-[250px]",
    "btn-classes": "tw-text-16 tw-font-medium !tw-px-25px",
    "dropdown-classes": "!tw-border-0 tw-shadow-[2px_5px_6px_hsla(0,0%,55%,.161)] !tw-rounded-t-none !tw-rounded-b-xl !tw-top-[42px] tw-font-medium",
    "dropdown-item-classes": "!tw-px-25px !tw-py-15px",
    "fieldset-classes": "!tw-border-0",
    namespace: "dropdown-agency-group",
    options: _ctx.franchiseList,
    "model-value": _ctx.agencySelected,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = function (option) {
      _ctx.selectedGroupAgency(option);
      _ctx.agencySelected = option;
    })
  }, null, 8 /* PROPS */, ["options", "model-value"])) : _createCommentVNode("v-if", true), _ctx.isAgencyActive ? (_openBlock(), _createElementBlock("div", _hoisted_20)) : _createCommentVNode("v-if", true), _ctx.isAgencyActive ? (_openBlock(), _createElementBlock("form", {
    key: 2,
    onSubmit: _cache[10] || (_cache[10] = _withModifiers(function () {}, ["prevent"]))
  }, [_createVNode(_component_base_input, {
    id: "valuationAddressDesktop",
    modelValue: _ctx.agencyFilter.name,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
      return _ctx.agencyFilter.name = $event;
    }),
    "data-cy": "agency-name-input",
    placeholder: "Agenzia",
    border: false,
    onFocusin: _cache[9] || (_cache[9] = function ($event) {
      _ctx.closeAgencyFranchiseList();
      _ctx.closePlaceDropdown();
    })
  }, null, 8 /* PROPS */, ["modelValue"])], 32 /* NEED_HYDRATION */)) : _createCommentVNode("v-if", true), _ctx.isAgencyActive ? (_openBlock(), _createElementBlock("div", _hoisted_21)) : _createCommentVNode("v-if", true), _ctx.isSearchActive || _ctx.isAgencyActive || _ctx.isTrendActive ? (_openBlock(), _createBlock(_component_place_box, {
    key: 4,
    "close-drop-down": _ctx.forceClosePlace,
    "has-error": _ctx.hasSearchError,
    "place-types": _ctx.placeTypes,
    place: _ctx.place,
    listing: false,
    "is-agency": _ctx.isAgencyActive,
    "show-place-map-drop-down": !_ctx.isTrendActive,
    onFocus: _ctx.closeMultiListingTypology,
    onFocusIn: _ctx.closeMultiListingTypology,
    onShowMap: _cache[11] || (_cache[11] = function ($event) {
      return _ctx.openModal('MAP');
    }),
    onEmitPlace: _ctx.getPlaceFromModal
  }, null, 8 /* PROPS */, ["close-drop-down", "has-error", "place-types", "place", "is-agency", "show-place-map-drop-down", "onFocus", "onFocusIn", "onEmitPlace"])) : _createCommentVNode("v-if", true), _createVNode(_component_base_button, {
    id: "home-desktop-search-btn",
    "data-cy": "search-btn-desktop",
    "btn-class": "tw-btn-w-primary tw-absolute",
    style: {
      "right": "20px"
    },
    disabled: !_ctx.isSearchReady,
    "is-loading": _ctx.isSearchLoading,
    onClick: _withModifiers(_ctx.handleSearch, ["stop", "prevent"])
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.labels.genericSearch), 1 /* TEXT */)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled", "is-loading", "onClick"])], 2 /* CLASS */)], 2 /* CLASS */), _ctx.valuation_tab ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    id: "valuation-tab-pane",
    "class": _normalizeClass(["tab-pane tw-flex tw-bg-white tw-m-0 tw-rounded-xl tw-py-6 tw-pl-25px tw-relative", {
      'active show': _ctx.isValuationActive
    }]),
    role: "tabpanel"
  }, [_ctx.isValuationActive ? (_openBlock(), _createBlock(_component_place_box, {
    key: 0,
    listing: false,
    "has-error": _ctx.hasValuationError,
    onFocus: _ctx.closeMultiListingTypology,
    onFocusIn: _ctx.closeMultiListingTypology
  }, null, 8 /* PROPS */, ["has-error", "onFocus", "onFocusIn"])) : _createCommentVNode("v-if", true), _createVNode(_component_base_button, {
    id: "home-desktop-valuate-btn",
    "data-cy": "valuate-btn",
    "btn-class": "tw-btn-w-primary tw-px-0 tw-absolute",
    disabled: _ctx.valuationAddressLoading,
    "is-loading": _ctx.isValuationOrSellingLoading,
    onClick: _cache[12] || (_cache[12] = function ($event) {
      return _ctx.valuationRedirect(false);
    })
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.labels.valuate), 1 /* TEXT */)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled", "is-loading"])], 2 /* CLASS */)) : _createCommentVNode("v-if", true), _ctx.sell_tab ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    id: "sell-tab-pane",
    "class": _normalizeClass(["tab-pane tw-flex tw-bg-white tw-m-0 tw-rounded-xl tw-py-6 tw-pl-25px tw-relative", {
      'active show': _ctx.isSellingActive
    }]),
    role: "tabpanel"
  }, [_ctx.isSellingActive ? (_openBlock(), _createBlock(_component_place_box, {
    key: 0,
    listing: false,
    "has-error": _ctx.hasValuationError,
    onFocus: _ctx.closeMultiListingTypology,
    onFocusIn: _ctx.closeMultiListingTypology
  }, null, 8 /* PROPS */, ["has-error", "onFocus", "onFocusIn"])) : _createCommentVNode("v-if", true), _createVNode(_component_base_button, {
    id: "home-desktop-".concat(_ctx.isSellingActive ? 'selling' : 'valuation', "-btn"),
    "data-cy": "".concat(_ctx.isSellingActive ? 'selling' : 'valuation', "-btn"),
    "btn-class": "tw-btn-w-primary tw-px-0 tw-absolute",
    disabled: _ctx.valuationAddressLoading,
    "is-loading": _ctx.isValuationOrSellingLoading,
    onClick: _cache[13] || (_cache[13] = _withModifiers(function ($event) {
      return _ctx.valuationRedirect(true);
    }, ["prevent", "stop"]))
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.labels.sell), 1 /* TEXT */)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["id", "data-cy", "disabled", "is-loading"])], 2 /* CLASS */)) : _createCommentVNode("v-if", true)]), _ctx.isAuctionActive ? (_openBlock(), _createBlock(_component_base_drop_down, {
    key: 0,
    id: "auction-filters",
    "class": "tw-w-full",
    "btn-label": _ctx.labels.showOtherFilters,
    "btn-classes": "tw-m-auto tw-text-w-primary tw-font-semibold tw-bg-w-cultured tw-justify-center tw-flex-row-reverse tw-gap-5px",
    "with-arrow-icon": true,
    "is-absolute": false,
    "close-when-clicked-outside": false,
    "data-cy": "auction-filters",
    "dropdown-classes": "tw-rounded-t !tw-shadow-none !tw-max-h-none !tw-overflow-y-visible",
    "arrow-color": "#2B5DFF"
  }, {
    "default": _withCtx(function (_ref) {
      var isOpen = _ref.isOpen;
      return [isOpen ? (_openBlock(), _createBlock(_component_auction_filters, {
        key: 0,
        "search-bean": _ctx.auctionFiltersSearchBean ? _ctx.auctionFiltersSearchBean : _ctx.searchBean,
        onChanged: _ctx.onChangedAuctionFiltersSearchBean
      }, null, 8 /* PROPS */, ["search-bean", "onChanged"])) : _createCommentVNode("v-if", true)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["btn-label"])) : _createCommentVNode("v-if", true)]), _ctx.modal == 'MAP' ? (_openBlock(), _createBlock(_component_map_modal, {
    key: 0,
    "show-map-modal": true,
    listing: false,
    onHideMapModal: _ctx.closeModal,
    onEmitPlace: _ctx.getPlaceFromMapModal
  }, null, 8 /* PROPS */, ["onHideMapModal", "onEmitPlace"])) : _ctx.modal === 'FILTERS_AGENCY_MODAL' ? (_openBlock(), _createBlock(_component_filters_agency_modal, {
    key: 1,
    "show-filters-agency-modal": true,
    onHideAgencyFilterModal: _ctx.closeModal,
    onFilterAgencyModal: _ctx.saveFilterAgency
  }, null, 8 /* PROPS */, ["onHideAgencyFilterModal", "onFilterAgencyModal"])) : _createCommentVNode("v-if", true)]);
}